module.exports = __webpack_public_path__ + "media/images/harris_testimonial_2x-38303ff6f30c18eaf92d018f4798b2d8.png";